export function DraggableOnStart(_event, uiData, draggleRef, setBounds) {

    const {clientWidth, clientHeight} = window.document.documentElement;

    const targetRect = draggleRef.current?.getBoundingClientRect();
    if (!targetRect) {
        return;
    }

    setBounds({
        left: -targetRect.left + uiData.x,
        right: clientWidth - (targetRect.right - uiData.x),
        top: -targetRect.top + uiData.y,
        bottom: clientHeight - (targetRect.bottom - uiData.y),
    });

}